import { SeriesLineOptions } from "highcharts";
import { IFundPriceHistory } from "@portal/types/api/IFundPriceHistory";

export const GetLineSeries = (
  isin: string,
  name: string,
  color: string,
  priceHistory: IFundPriceHistory[],
): SeriesLineOptions => {
  const serie = {
    id: isin,
    name: name,
    color: color,
    enableMouseTracking: true,
    data: priceHistory?.map(priceData => {
      return {
        x: new Date(priceData.navDate).getTime(),
        y: priceData.price,
      };
    }),
    type: "line",
    lineWidth: 1,
    turboThreshold: 0,
  } as SeriesLineOptions;
  return serie;
};

export const RiskData = (dataSeries: SeriesLineOptions[]) => {
  return {
    chart: {
      renderTo: "plot-container",
      type: "line",
      labels: { format: "{value:%Y-%m-%d}" },
    },
    accessibility: { enabled: false },
    credits: { enabled: false },
    title: null,
    xAxis: { title: null, type: "datetime" },
    yAxis: { title: null },
    legend: { labelFormat: "{name}" },
    tooltip: {
      xDateFormat: "%d.%m.%Y",
      crosshairs: { color: "var(--color-yellow)", zIndex: 3, dashStyle: "dash" },
      backgroundColor: "var(--color-white)",
      borderColor: "var(--color-blueDark)",
      borderRadius: 0,
      shadow: false,
    },
    series: dataSeries,
  };
};
